import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe extends DatePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const formattteValue = moment.utc(value).local().format('L LT');
    return super.transform(formattteValue, args[0]);
  }

}
